import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import RoutedHeader from '../Header';

import { SUPPORT_EMAIL } from '../../actions/urls';

import './styles.css';


const Component = ({
  authToken,
}) => {
  const btn = {
    text: 'Sign up',
    location: '/sign-up',
  };
  if (authToken) {
    btn.text = 'View Offers';
    btn.location = '/offers';
  }

  return (
    <div>
      <RoutedHeader />
      <div styleName="missionSection">
        <div styleName="sectionContainer">
          <div styleName="missionContainer">
            <div styleName="missionHeader">
              About My IPO
            </div>
            <div styleName="missionSubtext">
              At My IPO, our mission is to provide open access to selected IPOs and other Offerings.
            </div>
          </div>
        </div>
      </div>
      <div styleName="about">
        <div styleName="aboutTextSection">
          <div styleName="aboutMissionText">
            Until now, only the privileged clients of investment banks, institutional investors or the wealthy had access to IPOs and other Offerings. My IPO has changed this by creating a marketplace of selected IPOs and other Offerings that everyone can invest in.
            <br />
            <br />
            We believe that access to wealth creation should be universal and not just available to those that already have wealth or privileged access to these types of Offerings. My IPO was created to give all investors the opportunity to invest in some of the most exciting IPOs and other Offerings. It&#39;s easy to sign up, easy to use and equally easy to find Offerings to invest in.
            <br />
            <br />
            Please join us as we continue to fight for equal access to wealth creation.
          </div>
          <div styleName="contactUsText">
            <div styleName="contactUsHeader">
              Contact Us
            </div>
            <div>
              If you have any questions please email us at&nbsp;
              <a styleName="contactUsLink" href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>&nbsp;or give us a call at the telephone
              number below.  We’re available to help from 7:30am-4pm MST,
              Monday through Friday.
              <br />
              <br />
              My IPO
              <br />
              488 East Winchester Street, Suite 200
              <br />
              Salt Lake City, UT 84107
              <br />
              Toll Free: (844) 226-0640
              <br />
              <a styleName="contactUsLink" href="https://www.myipo.com">www.myipo.com</a>
            </div>
          </div>
        </div>
      </div>
      <div styleName="getStarted">
        <div styleName="getStartedSection">
          <div styleName="getStartedTitle">
            Get started today!
          </div>
          <Link styleName="signupBtn" to={btn.location}>
            { btn.text }
          </Link>
        </div>
      </div>
    </div>
  );
};

Component.displayName = 'About';

const mapStateToProps = state => ({
  authToken: state.authToken,
});

export default connect(mapStateToProps)(Component);



// WEBPACK FOOTER //
// ./src/components/About/index.js